<template>
  <div>
    <CJumbotron v-if="this.$store.state.data.access_level == 1" class="tickets">
      <h1 class="display-3">
        {{ $t("users.page_tittle") }}
      </h1>
      <p class="lead">
        <b
          style="
            font-weight: 100;
            color: #00325a;
            padding-bottom: 10px;
            display: inline-block;
          "
        >
          کاربری راهبران سیستم در این صفحه مدیریت می‌شود.
        </b>
      </p>
    </CJumbotron>

    <CCard>
      <CCardHeader class="hamkaran_header"> فیلتر گزارشات </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md="3">
            <CInput
              label="نام کاربر ...  "
              placeholder="عبارت را جهت جستجو وارد نمایید"
              v-on:keyup.enter="
                page = 1;
                pagPage = 1;
                pages = 0;
                getData();
              "
              v-model="q"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <div
          style="
            text-align: left;
            display: inline-block;
            float: left;
            margin-right: 10px;
          "
        >
          <CButton
            @click="
              page = 1;
              pagPage = 1;
              pages = 0;
              getData();
            "
            color="primary"
          >
            جستجو
          </CButton>
        </div>

        <div style="text-align: right; float: right; display: inline-block">
          <CButton style="color: #fff" @click="modal_show()" color="info">
            افزودن کاربر
          </CButton>
          
          <CButton
              style="margin-right: 9px;"
              :title="$t('user.status.1')"
              color="primary"
              :variant="(filters.status === '1')? '' : 'outline'"
              @click="filters.status=(filters.status === '1')? '' : '1';getData();"
            >
              {{ $t("users.status.1") }}
          </CButton>
          <CButton
              style="margin-right: 9px;"
              :title="$t('seedlings.status.0')"
              color="danger"
              :variant="(filters.status === '0')? '' : 'outline'"
              @click="filters.status=(filters.status === '0')? '' : '0';getData();"
            >
              {{ $t("users.status.0") }}
            </CButton>
        </div>
      </CCardFooter>
    </CCard>
    <CCard>
      <CCardBody class="mhcloud">
        <CElementCover v-if="loading" :opacity="1" class="h-loadin">
          <CSpinner size="5xl" />
          <br />
          <div>در حال بارگزاری</div>
        </CElementCover>
        <CRow v-if="showEmpty" class="nothing">
          <CCol lg="12" sm="12">
            <br /><br />
            <CIcon name="cil-warning" size="sm" />
            هیچ کاربری تعریف نشده است
            <br /><br /><br />
          </CCol>
        </CRow>
        <CRow
          class="d-sm-none d-lg-flex tickets_tables_header"
          v-if="showProducts"
        >
          <CCol lg="1" sm="1"> ID </CCol>

          <CCol lg="2" sm="8">
            {{ $t("users.name") }}
          </CCol>
          <CCol lg="2" sm="8">
            {{ $t("users.data.access_level.name") }}
          </CCol>
          <CCol lg="2" sm="1">
            {{ $t("users.mobile") }}
          </CCol>
          <CCol lg="2" sm="8">
            {{ $t("users.email") }}
          </CCol>

          <CCol lg="1" sm="4" :title="$t('users.data.status.help')">
            {{ $t("users.data.status.name") }}
          </CCol>

          <CCol lg="1" sm="0" :title="$t('users.data.submit_time.help')">
            {{ $t("users.data.submit_time.name") }}
          </CCol>

          <CCol lg="1" sm="0" :title="$t('users.data.operations.help')">
            {{ $t("users.data.operations.name") }}
          </CCol>
        </CRow>

        <CRow class="tickets_table" v-for="row in rows" :key="row.id">
          <CCol class="center" lg="1" sm="12">
            <span class="d-lg-none"> شناسه : </span>
            {{ row.prefix }}
          </CCol>
          <CCol style="flex-direction: row" class="center" lg="2" sm="12">
            <span class="d-lg-none"> {{ $t("users.name") }} : </span>
            {{ row.name }}
          </CCol>

          <CCol class="center" lg="2" sm="12" style="direction: ltr">
            <span class="d-lg-none">
              {{ $t("users.data.access_level.name") }} :
            </span>
            {{ $t(`users.access_level.${row.access_level}`) }}
          </CCol>
          <CCol class="center" lg="2" sm="12">
            <span class="d-lg-none"> {{ $t("users.mobile") }} : </span>
            {{ row.agent_mobile }}
          </CCol>

          <CCol class="center" lg="2" sm="12">
            <span class="d-lg-none"> {{ $t("users.mobile") }} : </span>
            {{ row.email }}
          </CCol>

          <CCol class="center" lg="1" sm="12">
            <span class="d-lg-none">
              {{ $t("users.data.status.name") }} :
            </span>
            {{ $t(`users.status.${row.active}`) }}
          </CCol>
          <CCol
            class="center"
            lg="1"
            sm="0"
            :title="
              new Date(row.created_at)
                | moment('dddd, jMMMM Do jYYYY, h:mm:ss a')
            "
          >
            <span class="d-lg-none">
              {{ $t("users.data.submit_time.name") }} :
            </span>
            {{ new Date(row.created_at) | moment("from", "now") }}
          </CCol>

          <CCol class="center" lg="1" sm="12">
            <CButtonGroup>
              <CButton
                :title="$t('users.data.edit.help')"
                color="success"
                size="sm"
                @click="whatsapp_modal(row)"
              >
                <i class="fa-brands fa-whatsapp"></i>
              </CButton>
              <CButton
                :title="$t('users.data.edit.help')"
                color="info"
                size="sm"
                @click="modal_show(row)"
              >
                <i class="fa-solid fa-edit"></i>
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <div id="integration">
      <CPagination
        :activePage.sync="pagPage"
        :pages="pages"
        v-on.update:activePage="changePage()"
        size="lg"
        align="center"
      />
    </div>

    <CModal :title="add_new.title" color="info" size="lg" :show.sync="showForm">
      <CRow>
        <CCol md="2">
          <CInput
            :label="$t('users.prefix')"
            :placeholder="$t('users.prefix_dec')"
            v-model="user.prefix"
          />
        </CCol>
        <CCol md="2">
          <CSelect
            :label="$t('users.data.status.name')"
            :placeholder="$t('users.data.status.placeholder')"
            :options="[
              { value: 1, label: $t('users.status.1') },
              { value: 0, label: $t('users.status.0') },
            ]"
            :value.sync="user.active"
          />
        </CCol>
        <CCol md="3">
          <CSelect
            :label="$t('users.data.access_level.name')"
            :placeholder="$t('users.data.access_level.name')"
            :options="[
              { value: 1, label: $t('users.access_level.1') },
              { value: 10, label: $t('users.access_level.10') },
              { value: 11, label: $t('users.access_level.11') },
              { value: 12, label: $t('users.access_level.12') },
              { value: 13, label: $t('users.access_level.13') },
              { value: 14, label: $t('users.access_level.14') },
              { value: 15, label: $t('users.access_level.15') },
              { value: 3, label: $t('users.access_level.3') },
              { value: 4, label: $t('users.access_level.4') },
            ]"
            :value.sync="user.access_level"
          />
        </CCol>
        <CCol md="5"> </CCol>
        <CCol md="4">
          <CInput
            :label="$t('users.name')"
            :placeholder="$t('users.data.name.placeholder')"
            v-model="user.name"
          />
        </CCol>

        <CCol md="4">
          <CInput
            :label="$t('users.mobile')"
            :placeholder="$t('users.mobile')"
            v-model="user.agent_mobile"
          />
        </CCol>

        <CCol md="4">
          <CInput
            :label="$t('users.email')"
            :placeholder="$t('users.email')"
            v-model="user.email"
          />
        </CCol>
        <CCol md="5">
          <CInput
            :label="$t('users.password_dec')"
            :placeholder="$t('users.password')"
            v-model="user.password"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="6">
          <span>کارکتر همکار</span>
          <VueFileAgent
            ref="character"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :linkable="true"
            :accept="'image/*'"
            :maxSize="'25MB'"
            :maxFiles="1"
            :helpText="$t('ticket.attachment_helpText')"
            :errorText="{
              type: $t('ticket.attachment_error.type'),
              size: $t('ticket.attachment_error.size'),
            }"
            @upload="onUpload($event)"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event, 'character')"
            @delete="fileDeleted($event)"
            v-model="user.character"
          >
          </VueFileAgent>
        </CCol>
        <CCol md="6">
          <span>آواتار همکار</span>
          <VueFileAgent
            ref="avatar"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :linkable="true"
            :accept="'image/*'"
            :maxSize="'25MB'"
            :maxFiles="1"
            :helpText="$t('ticket.attachment_helpText')"
            :errorText="{
              type: $t('ticket.attachment_error.type'),
              size: $t('ticket.attachment_error.size'),
            }"
            @upload="onUpload($event)"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event, 'avatar')"
            @delete="fileDeleted($event)"
            v-model="user.avatar"
          >
          </VueFileAgent>
        </CCol>
      </CRow>

      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="showForm = false"
      >
        {{ $t("common.CANCEL") }}
      </button>

      <CButton
        slot="footer"
        type="button"
        class="btn btn-info"
        @click="storeData()"
      >
        <CSpinner v-if="storeLoading" tag="span" size="md" />
        <CIcon v-if="!storeLoading" class="top_menu" name="cil-save" />
        <span v-if="!storeLoading"> {{ add_new.btn }} </span>
      </CButton>
    </CModal>


    <CModal :title="whatsapp_connect.title" color="info" size="lg" :show.sync="whatsapp_connect.modal">
      <CRow>
        <CCol md="12">

          <div class="whatsapp_connect_warper">
            <span class="status">
              <CSpinner v-if="!whatsapp_connect.step1.isDone" size="sm"  />
              <i v-if="whatsapp_connect.step1.isDone"  style="color: green;font-size: 1rem;" class="fa-solid fa-circle-check"></i>
            </span>
            <span class="title">
              {{ $t("users.whatsapp.step1") }}
            </span>
          </div>
          

          <div class="whatsapp_connect_warper" v-if="whatsapp_connect.step1.isDone">
            <span class="status">
              <CSpinner v-if="!whatsapp_connect.step2.isDone" size="sm"  />
              <i v-if="whatsapp_connect.step2.isDone"  style="color: green;font-size: 1rem;" class="fa-solid fa-circle-check"></i>
            </span>
            <span class="title">
              {{ $t("users.whatsapp.step2") }}

             <span  v-if="whatsapp_connect.step2.response"> : {{whatsapp_connect.step2.response.status }}</span>
            </span>

            <div style="text-align: center;" v-if="!whatsapp_connect.step2.isDone && whatsapp_connect.step2.response && whatsapp_connect.step2.response.status == 'QRCODE'">
              <img :src="whatsapp_connect.step2.response.qrcode" alt="">
            </div>
          </div>

        </CCol>
      </CRow>

      <button
        slot="footer"
        type="button"
        class="btn btn-secondary"
        @click="whatsapp_connect.modal = false"
      >
        {{ $t("common.CANCEL") }}
      </button>

      <CButton
        v-if="whatsapp_connect.step2.isDone"
        slot="footer"
        type="button"
        class="btn btn-danger"
        @click="restartWhatsapp()"
      >
        <CSpinner v-if="restartWhatsappLoading" tag="span" size="md" />
        <CIcon v-if="!restartWhatsappLoading" class="top_menu" name="cil-ban" />
        <span v-if="!restartWhatsappLoading"> خروج و بازنشانی </span>
      </CButton>
    </CModal>


    
  </div>
</template>
<style>
@media (max-width: 576px) {
  .whatsapp_connect_warper span {
    position: relative;
    display: inline-block;
}

.whatsapp_connect_warper span.title {
    padding-right: 7px;
    vertical-align: -3px;
}
  .row.d-sm-none.tickets_tables_header {
    display: none !important;
  }
  .row.tickets_table div {
    display: flex !important;
    justify-content: flex-start;
    align-content: flex-start;
    flex-direction: row;
    text-align: right;
    line-height: 30px;
  }
  .row.tickets_table div a.btn.btn-outline-primary {
    margin-top: 11px;
  }
}
span.bg_ani {
  top: -10px;
  position: absolute;
  left: -14px;
  opacity: 1;
  z-index: 0;
}

.red {
  color: #d40000;
}
.ltr.form-group input {
  direction: ltr;
}
.integrationMessage {
  position: absolute;
  display: block;
  right: 13px;
  /* float: right; */
}
.integration_help {
  text-align: right;
  background: #eee;
  padding: 19px 10px;
  margin-bottom: 15px;
  border-radius: 6px;
}
.box.not_active.not_membership {
  background: #fbcaca;
  border-color: #f56f6f;
  filter: blur(0.2px);
  color: red;
}
.box.not_active:hover {
  background: #efefef;
  animation: none;
  border: 1px solid #333;
  color: #727272;
}

.box.not_active {
  filter: blur(1px);
  cursor: no-drop;
}
.box img {
  width: 91px;
  line-height: 40px;
  display: inline-block;
  padding: 21px 10px;
  filter: grayscale(1);
}
.box {
  width: 106px;
  background: #efefef;
  transition: 0.3s all;
  height: 95px;
  border-radius: 5px;
  border: 1px solid #333;
  padding: 5px;
  cursor: pointer;
  margin: 14px 5px;
  float: right;
}
.box span {
  font-size: 12px;
}
.box i {
  display: block;
  font-size: 52px;
  padding-bottom: 8px;
  padding-top: 4px;
}
.mhcloud h1 {
  display: inline-block;
  width: 100%;
  text-align: right;
  font-weight: 100;
}
.box:hover {
  background: #01b0cf;
  color: #fff;
  border-color: #0091bb;
}
.edit_btn {
  width: 21px;
  height: 21px;
  padding: 0px;
  margin-right: 10px;
}
.box:hover {
  animation: zoom-in-zoom-out 2.5s ease-out infinite;
}
.tickets_table {
  border-radius: 3px;
  border: 1px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
}
.tickets_table:hover {
  cursor: pointer;
  background: rgba(238, 238, 238, 0.589);
}
.center {
  display: flex;
  align-content: space-around;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.row.tickets_tables_header {
  border-radius: 3px;
  border: 0px solid rgb(211 213 225 / 45%);
  padding: 10px 0px;
  text-align: center;
  margin: 5px 0px;
  color: #727272;
}
.jumbotron.tickets .btn {
  margin: 0px 5px;
}
.row.ticket p {
  white-space: break-spaces;
}
</style>
<script>
export default {
  watch: {
    "product.base_price"(val) {
      let formatted = new Intl.NumberFormat("en", {
        currency: "IRR",
        style: "currency",
      })
        .format(val)
        .replace("IRR", "");
      this.basePrice = formatted + " ریال";
    },
  },
  name: "Users",
  components: {},

  data() {
    return {
      data: null,
      page: 1,
      pagPage: 1,
      pages: 0,
      q: "",
      timeouts: [],
      showForm: false,
      storeLoading: false,
      rows: null,
      loading: true,
      restartWhatsappLoading:false,
      showProducts: false,
      showEmpty: false,
      basePrice: "",
      uploadUrl: "https://api.hamkaran.cloud/api/v1/files-upload",
      uploadHeaders: {},
      fileRecordsForUpload: [],
      filters: {
        user: "",
        status: '1'
      },
      whatsapp_connect:{
        modal:false,
        step:0,
        step1:{
          isDone:0,
        },
        step2:{
          isDone:0,
          response:'',
          qrcode:''
        }
      },
      user: {
        id: "",
        prefix: "",
        password: "",
        email: "",
        agent_mobile: "",
        company: "شرکت طرح و توسعه پردازش همکاران",
        name: "",
        active: "",
        access_level: "",
      },
      add_new: {
        title: "",
        btn: "",
      },
      lottie: {
        autoplay: true,
        speed: 1.5,
        loop: true,
        width: "260px",
      },
      lottie2: {
        autoplay: true,
        speed: 1.5,
        loop: true,
        width: "100px",
      },
    };
  },
  created() {
    this.$root.$i18n.locale = "en";
  },
  mounted() {
    this.q = this.$route.params.prefix ? this.$route.params.prefix : "";
    this.getData();
  },
  methods: {
    numberFormat(val) {
      let formatted = new Intl.NumberFormat("en", {
        currency: "IRR",
        style: "currency",
      })
        .format(val)
        .replace("IRR", "");
      return formatted + " ریال";
    },
    go(target) {
      this.$router.push({ path: target });
    },
    modal_show: function (data) {
      this.showForm = true;
      // add new
      if (data) {
        this.add_new.btn = this.$t("users.edit_btn");
        this.add_new.title = this.$t("users.edit_btn");
        this.user.id = data.id;
        this.user.name = data.name;
        this.user.prefix = data.prefix;
        this.user.active = data.active;
        this.user.email = data.email;
        this.user.agent_mobile = data.agent_mobile;
        this.user.mobile = data.mobile;
        this.user.access_level = data.access_level;
        this.user.character = JSON.parse(data.character);
        this.user.avatar = JSON.parse(data.avatar);
      } else {
        this.add_new.title = this.$t("users.add_new_btn");
        this.add_new.btn = this.$t("users.add_new_btn");
        this.user.id = 0;
        this.user.name = "";
        this.user.prefix = "";
        this.user.active = 1;
        this.user.email = "";
        this.user.agent_mobile = "";
        this.user.mobile = "";
        this.user.character = "";
        this.user.avatar = "";
      }
    },
    
    whatsapp_modal: function (data) {
      this.clearTimeouts();
      this.whatsapp_connect={
        modal:false,
        step:0,
        step1:{
          isDone:0,
        },
        step2:{
          isDone:0,
          response:'',
          qrcode:''
        }
      };
      this.whatsapp_connect.modal = true;
      this.whatsapp_connect.title = 'کاربر: '+data.name+' موبایل: '+data.agent_mobile;
      this.user.id =data.id;
      this.user.name = data.name;
      this.user.prefix = data.prefix;
      this.user.active = data.active;
      this.user.email = data.email;
      this.user.agent_mobile = data.agent_mobile;
      this.user.mobile = data.mobile;
      this.user.access_level = data.access_level;
      this.user.character = JSON.parse(data.character);
      this.user.avatar = JSON.parse(data.avatar);

      this.whatsapp(1);

    },

    clearTimeouts() {
      this.timeouts.forEach(clearTimeout);
      this.timeouts = []; 
    },
    whatsapp: function (step) {
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      var user = JSON.parse(JSON.stringify(this.user));
      user.step=step;
      axios
        .post("https://api.hamkaran.cloud/api/v1/admin/whatsapp/step"+step, user)
        .then((response) => {
          console.log(response);
          if(response.data.step == 'step1'){
            this.whatsapp_connect[response.data.step].isDone = 1;
            this.whatsapp(response.data.next_step);
          }
          
          if(response.data.step  == 'step2'){
            this.whatsapp_connect[response.data.step].response=response.data.response;
            if(response.data.response.status == 'CONNECTED'){
              this.whatsapp_connect[response.data.step].isDone = 1;
            }else{
              const timeoutId = setTimeout(() => this.whatsapp(response.data.next_step), 5000);
              this.timeouts.push(timeoutId); 
            }
          }
          
        })
        .catch((error) => {
          const count = this.$store.state.alert.errorcount + 1;
          console.log(error.response);
          this.storeLoading = false;
          const alert = {
            error_msg: {
              statusText: "خطا در  پردازش",
              status: error.response.status,
              data: error.response.data,
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },
    
    restartWhatsapp: function () {
      this.restartWhatsappLoading=true;

      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      var user = JSON.parse(JSON.stringify(this.user));
      axios
        .post("https://api.hamkaran.cloud/api/v1/admin/whatsapp/stop", user)
        .then((response) => {
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: null,
              status: null,
              data: [],
            },
            successMessage: "از واتساپ با موفقیت خارج شد",
            successcount: count,
            errorcount: 0,
          };
          this.$store.commit("set", ["alert", alert]);
          this.restartWhatsappLoading=false;
          this.clearTimeouts();
          this.whatsapp_connect.modal = false;
        })
        .catch((error) => {
          const count = this.$store.state.alert.errorcount + 1;
          console.log(error.response);
          this.storeLoading = false;
          const alert = {
            error_msg: {
              statusText: "خطا در  پردازش",
              status: error.response.status,
              data: error.response.data,
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },
    beforeDestroy() {
      this.clearTimeouts();
    },
    getData: function () {
      this.loading = true;
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;

      axios
        .get(
          "https://api.hamkaran.cloud/api/v1/admin/users?datefrom=" +
            "&page=" +
            this.page +
            "&q=" +
            this.q +
            "&user=" +
            this.filters.user +
            "&status=" +
            this.filters.status
        )
        .then((response) => {
          this.loading = false;
          this.rows = response.data.data.data;
          this.showProducts = this.rows.length > 0 ? 1 : 0;
          this.showEmpty = this.rows.length == 0 ? 1 : 0;
          this.pages = response.data.data.last_page;
        })
        .catch((error) => {
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: "Eroor",
              status: "500",
              data: ["خطا بارگزاری اطلاعات"],
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },

    changePage: function () {
      if (this.pages) {
        if (this.page != this.pagPage) {
          this.page = this.pagPage;
          this.getData();
        }
      }
    },

    storeData: function () {
      if (!this.storeLoading) {
        this.storeLoading = true;
        if (this.fileRecordsForUpload.length == 0) return this.saveData();
        this.$refs.character.upload(
          this.uploadUrl,
          this.uploadHeaders,
          this.fileRecordsForUpload
        );
        this.fileRecordsForUpload = [];
        // this.file_normalize();
      }
    },

    saveData: function () {
      var token = localStorage.getItem("token");
      if (token)
        axios.defaults.headers.common.Authorization = "Bearer " + token;
      axios
        .post("https://api.hamkaran.cloud/api/v1/admin/user", this.user)
        .then((response) => {
          this.storeLoading = false;
          this.showForm = false;
          this.getData();
          const count = this.$store.state.alert.successcount + 1;
          const alert = {
            error_msg: {
              statusText: null,
              status: null,
              data: [],
            },
            successMessage: "save succes",
            successcount: count,
            errorcount: 0,
          };
          this.$store.commit("set", ["alert", alert]);
        })
        .catch((error) => {
          const count = this.$store.state.alert.errorcount + 1;
          console.log(error.response);
          this.storeLoading = false;
          const alert = {
            error_msg: {
              statusText: "خطا در ذخیره سازی",
              status: error.response.status,
              data: error.response.data,
            },
            successMessage: "",
            successcount: 0,
            errorcount: count,
          };
          this.$store.commit("set", ["alert", alert]);
        });
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
    },
    onUpload(responses) {
      this.file_normalize();
      this.saveData();
    },
    file_normalize: function (name) {
      let xx = this;
      xx.user.avatar["urlResized"] =
        xx.user.avatar["upload"]["data"]["urlResized"];
      xx.user.avatar["name"] = xx.user.avatar["upload"]["data"]["name"];
      xx.user.avatar["url"] = xx.user.avatar["upload"]["data"]["urlResized"];

      xx.user.character["urlResized"] =
        xx.user.character["upload"]["data"]["urlResized"];
      xx.user.character["name"] = xx.user.character["upload"]["data"]["name"];
      xx.user.character["url"] =
        xx.user.character["upload"]["data"]["urlResized"];
    },
    fileDeleted: function (fileRecord) {
      console.log("fileDeleted");
    },
    onBeforeDelete: function (fileRecord, type) {
      console.log(fileRecord);
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        this.$refs[type].deleteFileRecord(fileRecord); // will trigger 'delete' event
      }
    },
  },
};
</script>
